import React, { useContext, useRef, useState } from "react";
import { AlertContext } from "../../../context/AlertContext";
import { CartContext } from "../../../context/CartContext";
import classes from "./ProductItem.module.css";
import Modal from "../../utilities/Modal";
import ButtonClose from "../../utilities/ButtonClose";
import { ReactComponent as IconCoin } from "../../../assets/coin.svg";
import { ReactComponent as IconView } from "../../../assets/view.svg";
import useDeviceType from '../../../customHook/useDeviceType';

const fetchConfig = async () => {
  try {
    const response = await fetch('/config.json');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Erro ao buscar o config:", error);
    return null;
  }
};
const config = await fetchConfig();

const fetchStrings = async () => {
  try {
    const response = await fetch(`${config.url}/catalogo/${config.diretorio}/mensagens.json?v=${crypto.randomUUID()}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Erro ao buscar os produtos:", error);
    return [];
  }
};
const strings = await fetchStrings();

const ProductItem = ({ name, img, price, uuid }) => {
  const isMobile = useDeviceType();
  const [amount, setAmount] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false); // Estado para controlar o modal
  const [modalContent, setModalContent] = useState({ title: "", img: "" }); // Conteúdo do modal
  const animaTimeout = useRef();

  const { addItem } = useContext(CartContext);
  const { showAlert } = useContext(AlertContext);

  const addItemToCartHandler = (e) => {
    e.preventDefault();
    clearTimeout(animaTimeout.current);
    addItem({
      name: name,
      price: price,
      amount: +amount,
      img: img,
    });
  };

  const viewerImageProduct = (e) => {
    e.preventDefault();
    // Defina o título e a imagem no estado do modal e abra o modal
    setModalContent({ title: name, img: `${config.url}/catalogo/${config.diretorio}/imagens/${img}` });
    setIsModalOpen(true); // Abrir o modal
  }

  const gotoPageProductItem = (e) => {
    e.preventDefault();
    window.open(`https://personalia.com.br/${config.diretorio}/view?u=${uuid}`);
  };

  const gotoPedidoItem = (e) => {
    e.preventDefault();
    window.open(`https://${isMobile ? 'api' : 'web'}.whatsapp.com/send?phone=5548991676165&text=${strings.whatsappbuy}%0A%0A${name}%0Ahttps://personalia.com.br/${config.diretorio}/view?u=${uuid}`);
  };

  const closeModalHandler = () => {
    setIsModalOpen(false); // Fechar o modal
  };

  function formatNumberAndPrice(value, onlyNumber=false) {
    if (typeof value !== 'number' && typeof value !== 'string') {
      return 'R$ 0,00';
    }
    const numero = parseFloat(value);
    if (isNaN(numero)) {
      return 'R$ 0,00';
    }
    if (onlyNumber) {
      return numero.toLocaleString('pt-BR', {
        minimumFractionDigits: 0
      });
    } else {
      return numero.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
      });
    }
  }

  return (
    <li className={classes.card} title={name}>
      <div className={classes.imgContainer} onClick={viewerImageProduct}>
        <img src={`${config.url}/catalogo/${config.diretorio}/imagens/${img}`} alt={name} />
      </div>
      <div className={classes.infos}>
        <div className={classes.infosItem}>
          <p className={classes.name}>{name}</p>
        </div>

        <div className={classes.flex}>
          <p className={classes.price}>{formatNumberAndPrice(price)}</p>
        </div>

        <div className={classes.flex}>
          <form className={classes.amountForm}>
            {/* <button
              className={classes.btnView}
              onClick={viewerImageProduct}
              title="Ver"
            >
              <IconView />
            </button> */}
            <button
              className={classes.btnBuy}
              onClick={gotoPageProductItem}
              title="Abrir"
            >
              <span>Abrir</span> <IconView />
            </button>
            <button
              className={classes.btnBuy}
              onClick={gotoPedidoItem}
              title="Comprar"
            >
              <span>Comprar</span> <IconCoin />
            </button>
          </form>
        </div>

      </div>

      {/* Exibir o modal se estiver aberto */}
      {isModalOpen && (
        <Modal onClose={closeModalHandler} isDarkMode={false}>
          <h2>{modalContent.title}</h2>
          <img src={modalContent.img} alt={modalContent.title} />
          <ButtonClose onClose={closeModalHandler} />
        </Modal>
      )}
    </li>
  );
};

export default ProductItem;
